var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"iconify iconify--emojione-monotone",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"2 2 60 60"}},[_c('path',{attrs:{"d":"M32 2C15.432 2 2 15.431 2 32c0 16.569 13.432 30 30 30s30-13.432 30-30C62 15.431 48.568 2 32 2m11.754 20.629h-8.682v23.878h-6.104V22.629h-8.721v-5.138h23.506v5.138z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }